module.exports = __webpack_public_path__ + "images/editDarkBg.0de003a1.svg";